import { AMPLIFY_KEYS } from './accounts';

export const deleteLocalStorageAuth = () => {
  Object.values(AMPLIFY_KEYS).forEach((key) => localStorage.removeItem(key));
};
